import { render, staticRenderFns } from "./BikyConfigSidebar.vue?vue&type=template&id=5b46e462&scoped=true&"
import script from "./BikyConfigSidebar.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigSidebar.vue?vue&type=style&index=0&id=5b46e462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b46e462",
  null
  
)

export default component.exports